app.mediator.registerModule(MODULE_NAME__MAIN_NAV, function(app) {

    var helpers = app.helpers.funcs;
    var fixedTopClass = 'navbar-fixed-top-custom';

    // If another module that is sticky behaviour is detected, the value of this variable gets set to true.
    // This should cause this module to not try to stick itself. (Which would cause overlapping / display bugs).
    var stickynessSlotIsOccupied = false;

    var hideStuckTimeout;

	return {

        showHideInterval: 3000,
        $rootElem: null,

		//==========================================================xdiv2====
		// Start and stop
		//===================================================================

        onLoaded: function (data) {
            var scope = this;
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                scope.init();
            }
        },

		init: function() {

			// Init
			var scope = this;
            this.$rootElem = $('.main-nav');
            if (!this.$rootElem.length) return;

            this.logOriginalOffset();

            scope.addDomListeners();
            scope.addMediatorListeners();

            // DOM event listeners
            app.globalEventRegistry.addListener('resize', function () {
                scope.logOriginalOffset();
                scope.conditionallyStick();
                scope.closeIfOpenAndScreenIsBig();
            });

            // There is a bug in safari whereby things with fixed positions jitter about
            // on scroll. We can mitigate this by more aggressively gating the amount of
            // times that we respond to a scroll event firing when in safari.
            function respondToScroll() {
                scope.logOriginalOffset();
                scope.conditionallyStick();
            }
            if (helpers.isSafari()) {
                $(window).on('scroll touchmove', helpers.throttler(function (e) {
                    respondToScroll();
                }, 500));
                $(window).on('mousewheel', helpers.throttler(function (e) {
                    respondToScroll();
                }, 25));
            } else {
                $(window).on('scroll touchmove', helpers.throttler(function (e) {
                    respondToScroll();
                }, 25));
            }

            var lastScrollTop = 0;
            $(window).on('scroll touchmove', function (e) {

                var scrollTop = $(this).scrollTop();

                // Unstick if we are back at the top
                if (scrollTop < scope.topOffset) {
                    scope.unstick();
                    return;
                }

                // If the menu has not been stuck, then we are scrolling while near the top of the page.
                // In such a circumstance, we want the nav to follow you down without hiding, regardless
                // of the direction being scrolled in.
                if (!scope.isStuck()) {
                    scope.showStuck();
                    return;
                }

                // Otherwise, we are scrolling at a position further down the page:
                // Only stick or unstick based on scroll direction.
                if (scrollTop < lastScrollTop) {
                    scope.showStuck();
                }
                scope.restartHideTimeout();
                lastScrollTop = scrollTop;
            });
		},

        addDomListeners: function () {
            var scope = this;

			this.$rootElem.find('.geo-trigger').click(function(e) {
                app.mediator.notify(EVENT_NAME__MAIN_NAV__LANGUAGE_SELECT_BUTTON_CLICKED, {
                    target: e.target
                });
			});

            $('#main-nav').on('show.bs.collapse', function () {
                app.mediator.notify(EVENT_NAME__MAIN_NAV__OPENING);
                scope.setBodyClass(EVENT_NAME__MAIN_NAV__OPENING);
                clearTimeout(hideStuckTimeout);
            });

            $('#main-nav').on('shown.bs.collapse', function () {
                app.mediator.notify(EVENT_NAME__MAIN_NAV__OPENED);
                scope.setBodyClass(EVENT_NAME__MAIN_NAV__OPENED);
                setTimeout(function () {
                    var screenSize = helpers.getScreenSize();
                    if (screenSize == app.helpers.screenBreakpoints.xs || screenSize == app.helpers.screenBreakpoints.sm) {
                        scope.goToFirstItem();
                        var $btn = scope.$rootElem.find('[data-toggle=collapse]');
                        $btn.find('.show-text').attr('aria-hidden', 'true');
                        $btn.find('.hide-text').removeAttr('aria-hidden');
                    }
                }, 350); // Allow for CSS transition to show everything before focus
            });

            $('#main-nav').on('hide.bs.collapse', function () {
                app.mediator.notify(EVENT_NAME__MAIN_NAV__CLOSING);
                scope.setBodyClass(EVENT_NAME__MAIN_NAV__CLOSING);
                var screenSize = helpers.getScreenSize();
                if (screenSize == app.helpers.screenBreakpoints.xs || screenSize == app.helpers.screenBreakpoints.sm) {
                    var $btn = scope.$rootElem.find('[data-toggle=collapse]');
                    $btn.find('.hide-text').attr('aria-hidden', 'true');
                    $btn.find('.show-text').removeAttr('aria-hidden');
                }
            });

            $('#main-nav').on('hidden.bs.collapse', function () {
                app.mediator.notify(EVENT_NAME__MAIN_NAV__CLOSED);
                scope.setBodyClass(EVENT_NAME__MAIN_NAV__CLOSED);
                var screenSize = helpers.getScreenSize();
                if (screenSize == app.helpers.screenBreakpoints.xs || screenSize == app.helpers.screenBreakpoints.sm) {
                    scope.goToMainToggleButton();
                };
                scope.restartHideTimeout();
            });

            // Close menu on escape key press
            $(document).keyup(function (e) {
                var $focused = $(':focus');
                var isChildOfMenu = !!$focused.closest('.main-nav').length;
                if (e.keyCode === 27 && isChildOfMenu) {
                    scope.close();
                }
            });
        },

        addMediatorListeners: function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__GEO_SELECT__CLOSED, function (data) {
                if ($(data.lastOpenedByElem).closest('.main-nav').length) {
                    scope.goToGeoSelectToggleButton();
                }
            });
            app.mediator.addListener(EVENT_NAME__STICKY_FOLLOWER_TOP__WITH_STICKY_INITIATED, function (data) {
                scope.respondToStickySlotBecomingOccupied();
            });
            app.mediator.addListener(EVENT_NAME__GEO_SELECT__OPENED, function () {
                scope.close();
            });
        },
		
		//==========================================================xdiv2====
		// Module
		//===================================================================

        setBodyClass: function (newStateKey) {
            var classes = {};
            classes[EVENT_NAME__MAIN_NAV__OPENING] = 'main-nav-state-opening';
            classes[EVENT_NAME__MAIN_NAV__OPENED] = 'main-nav-state-open';
            classes[EVENT_NAME__MAIN_NAV__CLOSING] = 'main-nav-state-closing';
            classes[EVENT_NAME__MAIN_NAV__CLOSED] = 'main-nav-state-closed';
            Object.keys(classes).forEach(function (theClassKey) {
                $('body').removeClass(classes[theClassKey]);
            });
            $('body').addClass(classes[newStateKey]);
        },

        closeIfOpenAndScreenIsBig: function () {
            var scope = this;
            var currentBreakpoint = app.helpers.funcs.getScreenSize();
            if ($.inArray(currentBreakpoint, [app.helpers.screenBreakpoints.md, app.helpers.screenBreakpoints.lg]) > -1 && $('#main-nav').hasClass('in')) {
                this.close();
                setTimeout(function () {
                    scope.$rootElem.find('.dropdown').removeClass('focused');
                }, 500);
            }
        },

        // ------------------------------------
        // Sticking
        // ------------------------------------

        topOffset: null,
        
        restartHideTimeout: function() {
            var scope = this;
            clearTimeout(hideStuckTimeout);
            hideStuckTimeout = setTimeout(function() {
                scope.hideStuck();
            }, scope.showHideInterval);
        },

        respondToStickySlotBecomingOccupied: function () {
            this.stickynessSlotIsOccupied = true;
            this.unstick();
        },

        logOriginalOffset: function () {

            // Don't try to log the original offset if the nav is already sticky.
            // - This will just give us an inaccurate result.
            if (this.$rootElem.hasClass('navbar-fixed-top-custom')) {
                return;
            }

            this.$rootElem.removeClass(fixedTopClass);
            this.topOffset = this.$rootElem.offset().top > 0 ? this.$rootElem.offset().top : this.topOffset;
        },

        conditionallyStick: function () {

            // Don't try to stick the navbar to the top of the page if the subscribe CTA is already stuck there.
            if (this.stickynessSlotIsOccupied) return;

            // Don't try to stick the navbar if the mobile menu is open,
            // as it will cause the menu to jump about when the user is trying to use it.
            if ($.inArray(app.helpers.funcs.getScreenSize(), [app.helpers.screenBreakpoints.xs, app.helpers.screenBreakpoints.sm]) > -1 && this.$rootElem.find('.navbar-collapse').hasClass('in')) {
                return;
            }
            var screenTop = $(window).scrollTop();
            if (screenTop > this.topOffset) {
                this.stick();
            } else {
                this.unstick();
            }
        },

        stick: function () {
            // By creating space in the box model that is the same height as the element that we just removed from the box model,
            // (by making it static), the rest of the page content doesn't "jump up".
            var scope = this;
            var height = scope.$rootElem.find('.navbar-brand').outerHeight();
            $('.main-nav-sticky-follower-top-placeholder').css({ height: height });
            if (!scope.$rootElem.hasClass(fixedTopClass)) {
                scope.$rootElem.addClass(fixedTopClass);
            }
        },

        unstick: function () {
            var scope = this;
            if (scope.$rootElem) {
                $('.main-nav-sticky-follower-top-placeholder').css({ height: '' });
                if (scope.$rootElem.hasClass(fixedTopClass)) {
                    scope.$rootElem.removeClass(fixedTopClass);
                }
            }
        },

        isStuck: function () {
            return this.$rootElem.hasClass(fixedTopClass);
        },

        showStuck: function () {
            if (!this.$rootElem.hasClass('stuck-shown')) {
                this.$rootElem.addClass('stuck-shown');
            }
        },

        hideStuck: function () {
            var currentBreakpoint = app.helpers.funcs.getScreenSize();
            var mobileMenuIsOpen = this.$rootElem.find('#main-nav').hasClass('in') &&
                [app.helpers.screenBreakpoints.xs, app.helpers.screenBreakpoints.sm].indexOf(currentBreakpoint) > -1;
            var desktopMenuIsOpen = false;
            var $dropdownMenus = this.$rootElem.find('.navbar-right .dropdown-menu');
            $dropdownMenus.each(function (ddMenuKey, ddMenu) {
                if ((!$(ddMenu).hasClass('hidden-dropdown-menu')) &&
                    [app.helpers.screenBreakpoints.md, app.helpers.screenBreakpoints.lg].indexOf(currentBreakpoint) > -1) {
                    desktopMenuIsOpen = true;
                }
            });
            var menuIsOpen = mobileMenuIsOpen || desktopMenuIsOpen;
            var scrollTop = $(window).scrollTop();
            var height = this.$rootElem.find('.navbar-brand').outerHeight();
            var combinedHeight = this.topOffset + height;
            var userHasScrolledEnoughToHideMenu = scrollTop > combinedHeight;
            if (this.$rootElem.hasClass('stuck-shown') && (!menuIsOpen) && userHasScrolledEnoughToHideMenu) {
                this.$rootElem.removeClass('stuck-shown');
            }
        },

        // ------------------------------------
        // Misc
        // ------------------------------------

        goToMainToggleButton: function () {
            this.$rootElem.find('button.main-navbar-toggle').focus();
        },

        goToGeoSelectToggleButton: function () {
            this.$rootElem.find('.geo-trigger').focus();
        },

        goToFirstItem: function () {
            this.$rootElem.find('.navbar-right > li:first-child > a').focus();
        },

        close: function () {
            var $mainNav = $('#main-nav');
            var isOpen = $mainNav.hasClass('in');
            if (isOpen) {
                $('.main-navbar-toggle').trigger('click');
                this.goToMainToggleButton();
            }
        },

        open: function () {
            var $mainNav = $('#main-nav');
            var isOpen = $mainNav.hasClass('in');
            if (!isOpen) $('.main-navbar-toggle').trigger('click');
        }

	};
});
